/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Plan_EveryInputs */



/**
* | output |
* | --- |
* | "Every plan" |
*
* @param {Products_Plan_EveryInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_plan_every = /** @type {((inputs?: Products_Plan_EveryInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Plan_EveryInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Любой тариф")
	return /** @type {LocalizedString} */ ("Every plan")
});